import React from 'react';
import './App.css';
import Editor from './Components/Editor'
const App = props => {
    return (
        <Editor />
    )
}

export default App;
